export const CHANGE_COLOR = "CHANGE_COLOR";
export const UPDATE_CANVAS = "UPDATE_CANVAS";
export const NEW_CANVAS = "NEW_CANVAS";
